exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-4c307b76],\r\na[data-v-4c307b76]:hover {\r\n    color: #0cdb8f !important;\r\n    cursor: pointer !important;\r\n    text-decoration: underline !important;\r\n    font-weight: bold !important;\n}\r\n", ""]);

// exports
